export const fetchBlogs = async (setter, setLoading, setError, blog_id) => {
    setLoading(true);
    try { 
        const url = new URL(`/api/v1/blog/${blog_id ? blog_id : ''}`, window.location.origin);
        
        const response = await fetch(url, {
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }else{
            const data = await response.json();
            setter(data);
        }
        
    } catch (error) {
        console.error('Error fetching blogs:', error);
        setError("Error fetching blogs");
        setter({});
    } finally {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }
};